import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { SignalRService } from '../../../services/signalr.service';
import { StudySearchStrategyExecuteResult } from '../../../models/search-strategy-execute-result.model';

export const HUB_CON_EVENT_EXECUTE_STUDY_SEARCH_STRATEGY = 'execute_study_search_strategy';

@Injectable({
  providedIn: 'root',
})
export class SearchStrategyNotificationService implements OnDestroy {
  public searchStrategyExecutionResult$: Subject<StudySearchStrategyExecuteResult> = new Subject<StudySearchStrategyExecuteResult>();

  constructor(private signalRService: SignalRService) {
    this.bindSignalR();
  }

  bindSignalR() {
    this.signalRService.hubConnection.on(HUB_CON_EVENT_EXECUTE_STUDY_SEARCH_STRATEGY, (result: StudySearchStrategyExecuteResult) => {
      this.searchStrategyExecutionResult$.next(result);
    });
  }

  ngOnDestroy() {
    this.signalRService.hubConnection.off(HUB_CON_EVENT_EXECUTE_STUDY_SEARCH_STRATEGY);
  }
}
